import React from "react";
import { TOTAL_SCREENS } from "../utilities/commonUtils";

export const ProtContainer = () => {
  const mapAllScreens = () => {
    return TOTAL_SCREENS.map((screen) =>
      screen.compoonent ? (
        <screen.compoonent screenName={screen.screen_name} key={screen.screen_name} id={screen.screen_name} />
      ) : (
        <div key={screen.screen_name}></div>
      )
    );
  };
  return <div className="port-container">{mapAllScreens()}</div>;
};
